import React from 'react';
import {connectDynamic, DynamicComponent} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import ReadOnlyModules from 'app-ui-componentlibrary/dist/go/components/common/content';

/* Wraps content components (Read only components), passes them props from the config */
/* config example, note that that dependencyAsContent must refer to te dataPath of the prop
   to receive as data (in this case,)
  {
    "type": "DynamicContentWrapper",
    "renderAs": "TextBlock",
    "renderWith": {
      "title": "My title to be rendered by text block",
      "isBold": false,
      "infoText": "Info!"
    }
    "dependencies": ["context.grant.orgId"]
    "dataAsContent": "dependency.orgId"
  },
  {
    "type": "DynamicContentWrapper",
    "renderAs": "TextBlock",
    "renderWith": {
      "title": "My title to be rendered by text block",
      "isBold": false,
      "infoText": "Info!"
    }
    "dataAsContent": "programmaticReview.orgId"
  }
  
*/
export class DynamicContentWrapper extends DynamicComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const mapping = {...ReadOnlyModules};
    const {renderAs, renderWith} = this.props;
    const ReadOnly = mapping[renderAs];
    let {dataAsContent} = this.props;
    let valueFromData = this.props.content;
    let matchingString = 'dependencies.';
    if (dataAsContent && dataAsContent.indexOf(matchingString) !== -1) {
      // gets the data from the dynamicComponent
      const field = dataAsContent.split(matchingString)[1];
      valueFromData = _.get(this.props, field);
    } else if (dataAsContent) {
      // gets the data from this views's data
      valueFromData = _.get(this.props.data, dataAsContent);
    }
    const toPass = {
      content: valueFromData,
      ...renderWith,
    };
    return <ReadOnly {...toPass} />;
  }
}

export default connectDynamic(DynamicContentWrapper);
